import React from 'react'

import BasePlaceholder from './BasePlaceholder'

export default ({ ...rest }) => <BasePlaceholder {...rest} />
